import React, { useEffect, useState } from "react";
import ReactTable from "react-table";
import { Button } from "reactstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faFileExport } from "@fortawesome/free-solid-svg-icons";
import s from "./styles.scss";
import ContactCenterResumen from "../../../../types/ContactCenterResumen";
import { formatMoney, formatPercent } from "../../../helpers/formatters";

export interface TableProps {
  data: ContactCenterResumen[];
  loading: boolean;
  onDownloadCsv: () => void;
  descargando: boolean;
}

export const MemoTable = React.memo(
  ({ data, loading, onDownloadCsv, descargando }: TableProps) => {
    const [columns, setColumns] = useState(columnsFormatter());

    useEffect(() => {
      setColumns(columnsFormatter());
    }, []);

    const totalComisiones =
      data && data.length > 0
        ? data.reduce((sum, item) => sum + (item.totalComision || 0), 0)
        : 0;

    return (
      <>
        <div className="row mb-2">
          <div className="col-6 p-0 pt-2">
            {data && data.length > 0 ? (
              <span>
                Comisiones mostradas: {data.length} -{" "}
                {formatMoney(totalComisiones)}
              </span>
            ) : (
              <span>
                No se encontraron comisiones para el periodo seleccionado
              </span>
            )}
          </div>
          <div className="col-6 p-0 text-right">
            {data && data.length > 0 && (
              <>
                <span>Exportar a CSV: </span>
                <Button
                  id="btnReportExportCsv"
                  color="link"
                  type="button"
                  onClick={onDownloadCsv}
                  disabled={descargando}
                >
                  <FontAwesomeIcon icon={faFileExport} color="black" />
                </Button>
              </>
            )}
          </div>
        </div>

        <div className="row mt-2">
          <div style={{ width: "100%" }}>
            <ReactTable
              data={data || []}
              columns={columns}
              loading={loading}
              defaultPageSize={50}
              className="-striped -highlight"
              showPagination={true}
              showPageSizeOptions={false}
              getTrProps={() => ({ style: { height: "30px" } })}
              sortable={false}
            />
          </div>
        </div>
      </>
    );
  }
);

function columnsFormatter() {
  return [
    {
      Header: "No. Emp.",
      id: "numeroEmpleado",
      className: s.tdClear,
      headerClassName: "text-left",
      width: 64,
      accessor: simpleAccessor("numeroEmpleado")
    },
    {
      Header: "Empleado",
      id: "empleadoNombre",
      className: s.tdClear,
      headerClassName: "text-left",
      width: 172,
      accessor: simpleAccessor("empleadoNombre")
    },
    {
      Header: "Tipo",
      id: "tipo",
      width: 100,
      className: s.tdClear,
      headerClassName: "text-left",
      accessor: (row: ContactCenterResumen) => {
        const tipo = row.esSupervisor ? "Supervisor" : "Chater";
        return <div className={s.field}>{tipo}</div>;
      }
    },
    {
      Header: "Nuevo Ing.",
      id: "esEmpleadoNuevo",
      width: 100,
      className: s.tdClear,
      headerClassName: "text-left",
      accessor: (row: ContactCenterResumen) => {
        const valor = row.esEmpleadoNuevo ? "Sí" : "No";
        return <div className={s.field}>{valor}</div>;
      }
    },
    {
      Header: "% Citas",
      id: "citasAlcance",
      width: 80,
      className: s.tdClear,
      headerClassName: "text-left",
      accessor: percentAccessor("citasAlcance")
    },
    {
      Header: "Comisión Citas",
      id: "citaComisionTotal",
      width: 120,
      className: s.tdClear,
      headerClassName: "text-left",
      accessor: moneyAccessor("citaComisionTotal")
    },
    {
      Header: "% Conversión",
      id: "conversionAlcance",
      width: 110,
      className: s.tdClear,
      headerClassName: "text-left",
      accessor: percentAccessor("conversionAlcance")
    },
    {
      Header: "Bono Conv.",
      id: "conversionBono",
      width: 88,
      className: s.tdClear,
      headerClassName: "text-left",
      accessor: moneyAccessor("conversionBono")
    },
    {
      Header: "Descripción",
      id: "descripcion",
      className: s.tdClear,
      headerClassName: "text-left",
      accessor: simpleAccessor("descripcion")
    },
    {
      Header: "Total Comisión",
      id: "totalComision",
      width: 120,
      className: s.tdClear,
      headerClassName: "text-left",
      accessor: moneyAccessor("totalComision")
    }
  ];
}

function simpleAccessor(key: keyof ContactCenterResumen) {
  return (row: ContactCenterResumen) => {
    return <div className={s.field}>{row[key]}&nbsp;</div>;
  };
}

function percentAccessor(key: keyof ContactCenterResumen) {
  return (row: ContactCenterResumen) => {
    return (
      <div className={s.field}>
        {formatPercent(Number(row[key]) || 0)}&nbsp;
      </div>
    );
  };
}

function moneyAccessor(key: keyof ContactCenterResumen) {
  return (row: ContactCenterResumen) => {
    return (
      <div className={s.field}>
        {formatMoney(Number(row[key]) || 0, 2)}&nbsp;
      </div>
    );
  };
}
